import { createSelector } from '@reduxjs/toolkit';

import { getRequesterAttachments } from '@app/store/documentSetup/selectors';
import { getAttachmentRequestTotalCount } from '@app/store/template/selectors';
import { getAttachmentLimit } from '@app/store/user/authority/selectors';

const getTemplateAttachmentLimitReached = createSelector(
  getAttachmentLimit,
  getAttachmentRequestTotalCount,
  getRequesterAttachments,
  (limit, signinerAttachmentCount, requesterAttachments) =>
    limit <= signinerAttachmentCount + requesterAttachments.length
);

export default getTemplateAttachmentLimitReached;
